// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__W0nbA","error":"styles_error__2YayA","info":"styles_info__lpl8T","light":"styles_light__3f_Jp","title":"styles_title__3qVNL"};